// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
import { ErrorFragmentDoc } from '../../../../apps/dashboard/app/utils/queries.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ThreadFragment = { __typename?: 'AssistantThread', id: string, conversationId: string, createdAt: string, title: string, restaurant: { __typename?: 'Restaurant', id: string } };

export type CreateThreadMutationVariables = Types.Exact<{
  input: Types.CreateAssistantThreadMutationInput;
}>;


export type CreateThreadMutation = { __typename?: 'Mutation', createAssistantThread?: { __typename?: 'CreateAssistantThreadMutationPayload', assistantThread?: { __typename?: 'AssistantThread', id: string, conversationId: string, createdAt: string, title: string, restaurant: { __typename?: 'Restaurant', id: string } } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type EditThreadMutationVariables = Types.Exact<{
  input: Types.EditAssistantThreadMutationInput;
}>;


export type EditThreadMutation = { __typename?: 'Mutation', editAssistantThread?: { __typename?: 'EditAssistantThreadMutationPayload', assistantThread?: { __typename?: 'AssistantThread', id: string, conversationId: string, createdAt: string, title: string, restaurant: { __typename?: 'Restaurant', id: string } } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type ThreadsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ThreadsQuery = { __typename?: 'Query', assistantThreads: Array<{ __typename?: 'AssistantThread', id: string, conversationId: string, createdAt: string, title: string, restaurant: { __typename?: 'Restaurant', id: string } }> };

export type SavedPromptFragment = { __typename?: 'SavedPrompt', id: string, prompt: string, title: string, position?: number | null, createdAt: string };

export type CreateSavedPromptMutationVariables = Types.Exact<{
  input: Types.CreateSavedPromptMutationInput;
}>;


export type CreateSavedPromptMutation = { __typename?: 'Mutation', createSavedPrompt?: { __typename?: 'CreateSavedPromptMutationPayload', savedPrompt?: { __typename?: 'SavedPrompt', id: string, prompt: string, title: string, position?: number | null, createdAt: string } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type EditSavedPromptMutationVariables = Types.Exact<{
  input: Types.EditSavedPromptMutationInput;
}>;


export type EditSavedPromptMutation = { __typename?: 'Mutation', editSavedPrompt?: { __typename?: 'EditSavedPromptMutationPayload', savedPrompt?: { __typename?: 'SavedPrompt', id: string, prompt: string, title: string, position?: number | null, createdAt: string } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type SavedPromptsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SavedPromptsQuery = { __typename?: 'Query', savedPrompts: Array<{ __typename?: 'SavedPrompt', id: string, prompt: string, title: string, position?: number | null, createdAt: string }> };

export const ThreadFragmentDoc = gql`
    fragment thread on AssistantThread {
  id
  conversationId
  createdAt
  restaurant {
    id
  }
  title
}
    `;
export const SavedPromptFragmentDoc = gql`
    fragment savedPrompt on SavedPrompt {
  id
  prompt
  title
  position
  createdAt
}
    `;
export const CreateThreadDocument = gql`
    mutation createThread($input: CreateAssistantThreadMutationInput!) {
  createAssistantThread(input: $input) {
    assistantThread {
      ...thread
    }
    errors {
      ...error
    }
  }
}
    ${ThreadFragmentDoc}
${ErrorFragmentDoc}`;

export function useCreateThreadMutation() {
  return Urql.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument);
};
export const EditThreadDocument = gql`
    mutation editThread($input: EditAssistantThreadMutationInput!) {
  editAssistantThread(input: $input) {
    assistantThread {
      ...thread
    }
    errors {
      ...error
    }
  }
}
    ${ThreadFragmentDoc}
${ErrorFragmentDoc}`;

export function useEditThreadMutation() {
  return Urql.useMutation<EditThreadMutation, EditThreadMutationVariables>(EditThreadDocument);
};
export const ThreadsDocument = gql`
    query threads {
  assistantThreads {
    ...thread
  }
}
    ${ThreadFragmentDoc}`;

export function useThreadsQuery(options?: Omit<Urql.UseQueryArgs<ThreadsQueryVariables>, 'query'>) {
  return Urql.useQuery<ThreadsQuery, ThreadsQueryVariables>({ query: ThreadsDocument, ...options });
};
export const CreateSavedPromptDocument = gql`
    mutation createSavedPrompt($input: CreateSavedPromptMutationInput!) {
  createSavedPrompt(input: $input) {
    savedPrompt {
      ...savedPrompt
    }
    errors {
      ...error
    }
  }
}
    ${SavedPromptFragmentDoc}
${ErrorFragmentDoc}`;

export function useCreateSavedPromptMutation() {
  return Urql.useMutation<CreateSavedPromptMutation, CreateSavedPromptMutationVariables>(CreateSavedPromptDocument);
};
export const EditSavedPromptDocument = gql`
    mutation editSavedPrompt($input: EditSavedPromptMutationInput!) {
  editSavedPrompt(input: $input) {
    savedPrompt {
      ...savedPrompt
    }
    errors {
      ...error
    }
  }
}
    ${SavedPromptFragmentDoc}
${ErrorFragmentDoc}`;

export function useEditSavedPromptMutation() {
  return Urql.useMutation<EditSavedPromptMutation, EditSavedPromptMutationVariables>(EditSavedPromptDocument);
};
export const SavedPromptsDocument = gql`
    query savedPrompts {
  savedPrompts {
    ...savedPrompt
  }
}
    ${SavedPromptFragmentDoc}`;

export function useSavedPromptsQuery(options?: Omit<Urql.UseQueryArgs<SavedPromptsQueryVariables>, 'query'>) {
  return Urql.useQuery<SavedPromptsQuery, SavedPromptsQueryVariables>({ query: SavedPromptsDocument, ...options });
};